// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W0Op","colMin":"styles_colMin__1Xf5h"};